import { initReactI18next } from 'react-i18next';
import i18n, { InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import COMMON_EN_TRANSLATION from './en/common.json';
import COMMON_ES_TRANSLATION from './es/common.json';
import COMMON_FR_TRANSLATION from './fr/common.json';
import COMMON_PT_TRANSLATION from './pt/common.json';

export const DefaultLanguage = 'en';
export const Languages = ['en', 'es', 'pt', 'fr'];

const options: InitOptions = {
  resources: {
    'en': {
      translation: COMMON_EN_TRANSLATION,
    },
    'es': {
      translation: COMMON_ES_TRANSLATION,
    },
    'fr': {
      translation: COMMON_FR_TRANSLATION,
    },
    'pt': {
      translation: COMMON_PT_TRANSLATION,
    }
  },
  fallbackLng: DefaultLanguage,
  supportedLngs: [...Languages],
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
};

export const initI18n = () => {
  i18n.use(LanguageDetector).use(initReactI18next).init(options);
};
